import { render, staticRenderFns } from "./ChartjsHorizontalBarChartWorkerTop.vue?vue&type=template&id=0add5ca7&"
import script from "./ChartjsHorizontalBarChartWorkerTop.vue?vue&type=script&lang=js&"
export * from "./ChartjsHorizontalBarChartWorkerTop.vue?vue&type=script&lang=js&"
import style0 from "./ChartjsHorizontalBarChartWorkerTop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports